<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="512"
        height="512"
        x="0"
        y="0"
        viewBox="0 0 24 24"
        style="enable-background: new 0 0 512 512"
        xml:space="preserve"
        class="">
        <g>
            <path
                d="M7 0H4C1.794 0 0 1.794 0 4v3c0 2.206 1.794 4 4 4h3c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4Zm3 7c0 1.654-1.346 3-3 3H4c-1.654 0-3-1.346-3-3V4c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3v3Zm10-7h-3c-2.206 0-4 1.794-4 4v3c0 2.206 1.794 4 4 4h3c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4Zm3 7c0 1.654-1.346 3-3 3h-3c-1.654 0-3-1.346-3-3V4c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3v3ZM7 13H4c-2.206 0-4 1.794-4 4v3c0 2.206 1.794 4 4 4h3c2.206 0 4-1.794 4-4v-3c0-2.206-1.794-4-4-4Zm3 7c0 1.654-1.346 3-3 3H4c-1.654 0-3-1.346-3-3v-3c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3v3Zm10-7h-3c-2.206 0-4 1.794-4 4v3c0 2.206 1.794 4 4 4h3c2.206 0 4-1.794 4-4v-3c0-2.206-1.794-4-4-4Zm3 7c0 1.654-1.346 3-3 3h-3c-1.654 0-3-1.346-3-3v-3c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3v3Z"
                fill="currentColor"
                opacity="1"
                data-original="currentColor"
                class=""></path>
        </g>
    </svg>
</template>
